<div class="container-fluid p-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-building me-2"></i>Fornecedores</h2>
      <p class="text-muted mb-0">Gerencie seus fornecedores e prestadores de serviço</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Novo Fornecedor
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="🔍 Buscar por nome, CNPJ, CPF, email..."
                 [value]="filter.search" (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!loading && result.items.length === 0" class="text-center py-5 text-muted">
        <i class="bi bi-inbox" style="font-size: 3rem;"></i>
        <p class="mt-2">Nenhum fornecedor encontrado</p>
      </div>

      <table *ngIf="!loading && result.items.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th>Nome</th>
            <th>CNPJ/CPF</th>
            <th>Email</th>
            <th>Telefone</th>
            <th>Criado em</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of result.items">
            <td><strong>{{ s.name }}</strong></td>
            <td>{{ s.cnpj || s.cpf || '-' }}</td>
            <td>{{ s.email || '-' }}</td>
            <td>{{ s.phone || '-' }}</td>
            <td>{{ fmtDate(s.createdAt) }}</td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-1" (click)="openModal(s)" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="delete(s)" title="Excluir">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginação -->
      <div *ngIf="result.totalCount > result.pageSize" class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted">
          Exibindo {{ result.items.length }} de {{ result.totalCount }} registros
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="result.page === 1">
              <a class="page-link" (click)="result.page > 1 && onPageChange(result.page - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let p of [].constructor(result.totalPages); let i = index"
                [class.active]="i + 1 === result.page">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="result.page === result.totalPages">
              <a class="page-link" (click)="result.page < result.totalPages && onPageChange(result.page + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingId ? 'Editar' : 'Novo' }} Fornecedor</h5>
        <button type="button" class="btn-close" (click)="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label">Nome <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="form.name">
          </div>
          <div class="col-md-6">
            <label class="form-label">CNPJ</label>
            <input type="text" class="form-control" [(ngModel)]="form.cnpj"
                   (input)="onCnpjInput($event)"
                   placeholder="00.000.000/0000-00" maxlength="18">
          </div>
          <div class="col-md-6">
            <label class="form-label">CPF</label>
            <input type="text" class="form-control" [(ngModel)]="form.cpf"
                   (input)="onCpfInput($event)"
                   placeholder="000.000.000-00" maxlength="14">
          </div>
          <div class="col-md-6">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" [(ngModel)]="form.email">
          </div>
          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" [(ngModel)]="form.phone"
                   (input)="onPhoneInput($event)"
                   placeholder="(00) 00000-0000" maxlength="15">
          </div>
          <div class="col-md-12">
            <label class="form-label">Endereço</label>
            <input type="text" class="form-control" [(ngModel)]="form.address">
          </div>
          <div class="col-md-12">
            <label class="form-label">Observações</label>
            <textarea class="form-control" [(ngModel)]="form.notes" rows="3"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showModal = false" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
